import React from 'react';

function mirror(o) {
  return o;
}

export default function mapSelf(children) {
  // return ReactFragment
  return React.Children.map(children, mirror);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.4.5.0@rc-util/es/Children/mapSelf.js
// module id = 295
// module chunks = 1